/* eslint-disable array-bracket-newline */
/**
 * Implement wagmi-like function with drop-in replacement
 */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import BigNumber from 'bignumber.js';
import axios from 'axios';
import { getSuccessfulElrondTransactions } from '../../../selectors/transactions';

type FetchBalanceArgs = {
  address: string;
  chainId?: number;
  token: string;
  enabled: boolean;
  onSuccess: (data: FetchBalanceResult) => void;
  onError: () => void;
};
type FetchBalanceResult = {
  decimals: number;
  formatted: string;
  symbol: string;
  value: BigNumber;
};

const tokenBalanceUrl = (address: string, token: string) =>
  `https://api.multiversx.com/accounts/${address}/tokens/${token}`;

const useElrondBalance = ({
  address,
  token,
  enabled,
  onSuccess,
  onError,
}: FetchBalanceArgs) => {
  const transactions = useSelector(getSuccessfulElrondTransactions);

  useEffect(() => {
    if (address && token && enabled) {
      const controller = new AbortController();
      axios
        .get(tokenBalanceUrl(address, token), { signal: controller.signal })
        .then((response) => {
          if (response.status == 200) {
            const { data } = response;
            onSuccess({
              decimals: data.decimals,
              formatted: BigNumber(data.balance)
                .div(10 ** data.decimals)
                .toString(),
              symbol: data.ticker,
              value: BigNumber(data.balance),
            });
          } else {
            onError();
          }
        })
        .catch(() => {
          onError();
        });

      () => {
        controller.abort();
      };
    }
  }, [address, token, transactions.length]);
};

export default useElrondBalance;
